import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement } from '../app/endpoints';
import axiosBaseQueryUserMangement from './axiosBaseQueryUserMangement';

export const HomeApi = createApi({
  reducerPath: 'HomeApi',
  baseQuery: axiosBaseQueryUserMangement({ baseUrl: process.env.REACT_APP_USER_MANAGEMENT_BASE_URL }),
  tagTypes: ['HomeApi'],
  endpoints: (builder) => ({
    getCityData: builder.mutation({
      query: (body) => {
        return {
          method: 'GET',
          url: `${userManagement.HomePageController.getCityData}/${body.payload.searchValue}/${body.payload.page}/${body.payload.offset}`,
        };
      },
    }),
    getData: builder.mutation({
      query: (body) => {
        return {
          url: `${userManagement.HomePageController.getData}/${body.payload.page}/${body.payload.offset}`,
          method: 'GET',
        };
      },
    }),
  }),
});


export const { useGetCityDataMutation, useGetDataMutation } = HomeApi;
